import { IExpandableTable } from "../models/models";

export class ExpandableTable implements IExpandableTable {
    expanded: boolean = false;
    toggleExpanded() {}
}